namespace $.$$ {
	export class $shm_hitalama_projects_map extends $.$shm_hitalama_projects_map {
		pages() {
			const projects = this.projects()
			if( !projects.projects_map_id() ) projects.projects_map_ensure()
			this.$.$shm_hitalama_map_templates.projects_sync(
				projects.pinned_map()!,
				projects.records_for_map(),
				projects.team(),
			)
			return [ projects.Pinned_map_book() ]
		}
	}
}
